<!--
 *                                                     __----~~~~~~~~~~~------___
 *                                    .  .   ~~//====......          __--~ ~~
 *                    -.            \_|//     |||\\  ~~~~~~::::... /~
 *                 ___-==_       _-~o~  \/    |||  \\            _/~~-
 *         __---~~~.==~||\=_    -_--~/_-~|-   |\\   \\        _/~
 *     _-~~     .=~    |  \\-_    '-~7  /-   /  ||    \      /
 *   .~       .~       |   \\ -_    /  /-   /   ||      \   /
 *  /  ____  /         |     \\ ~-_/  /|- _/   .||       \ /
 *  |~~    ~~|--~~~~--_ \     ~==-/   | \~--===~~        .\
 *           '         ~-|      /|    |-~\~~       __--~~
 *                       |-~~-_/ |    |   ~\_   _-~            /\
 *                            /  \     \__   \/~                \__
 *                        _--~ _/ | .-~~____--~-/                  ~~==.
 *                       ((->/~   '.|||' -_|    ~~-/ ,              . _||
 *                                  -_     ~\      ~~---l__i__i__i--~~_/
 *                                  _-~-__   ~)  \--______________--~~
 *                                //.-~~~-~_--~- |-------~~~~~~~~
 *                                       //.-~~~--\
 *                       ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 * 
 *                               神兽保佑            永无BUG
 * 
 * @Author: xupeng ‘18309854921@163.com’
 * @Date: 2024-09-02 13:47:07
 * @LastEditors: xupeng ‘18309854921@163.com’
 * @LastEditTime: 2024-09-10 10:41:34
 * @FilePath: \admin\src\views\warehouse\index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 -->

 <template>
    <div class="page_body">
        <div class="data_main">
            <div class="data_group">
                <el-button type="primary" size="small" @click="postParam">更新</el-button>
            </div>
        </div>
    </div>
</template>

<script>
import {getParam,postParam} from '@/api/index'
import {mapState} from "vuex";
export default {
  name: "contentArticleIndex",
  data () {
    return {
        token:'',
    }
  },
  computed: {
    ...mapState({
      listKeepAlive: state => state.app.listKeepAlive,
    })
  },
  activated () {
    this.getParam()
  },
  methods: {
    getParam(){
        getParam().then(res=>{
            console.log(res)
            this.token = res.data
        })
    },
    postParam(){
        postParam({data:this.token}).then(res=>{
            console.log(res)
            if (res.code == 0) {
                this.$message.success('服务器更新成功')
            }
        })
    },
  },
}
</script>
